<template>
  <items-batch-confirmation-dialog
    :description="`You are about to cancel the rates you suggested for ${items.length} loans:`"
    :execute="execute"
    item-id-key="id"
    :items="items"
    success-message="Cancellations successfully initiated."
    :table-headers="tableHeaders"
    title="Cancel Rerates"
    v-on="$listeners"
  >
    <template #row="{ item }">
      <td>
        {{ item.counterpartyDisplay }}
      </td>
      <td>{{ item.security.ticker }}</td>
      <td>{{ item.security.cusip }}</td>
      <td>
        <pretty-number :value="item.openQuantity" />
      </td>
      <td class="text-end">
        <rate-output :rate="item.rate" :rate-modifier="item.rateModifier" />
      </td>
      <td v-if="item.renegotiation" class="text-end">
        <rate-output
          :rate="item.renegotiation.rate"
          :rate-modifier="item.renegotiation.rateModifier"
        />
      </td>
    </template>
  </items-batch-confirmation-dialog>
</template>

<script lang="ts">
import ItemsBatchConfirmationDialog from '@/modules/common/components/ItemsBatchConfirmationDialog.vue';
import { BorrowerOpenLoan, LenderOpenLoan } from '@/modules/common/models';
import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
    ItemsBatchConfirmationDialog,
  },
  props: {
    items: Array as PropType<LenderOpenLoan[] | BorrowerOpenLoan[]>,
  },
})
export default class BatchCancelRenegotiateDialog extends Vue {
  protected readonly tableHeaders = [
    { text: 'Counterparty' },
    { text: 'Ticker' },
    { text: 'CUSIP' },
    { text: 'Open' },
    { text: 'Rebate Rate', align: 'end' },
    { text: 'Suggested Rate', align: 'end' },
  ];

  // props
  protected readonly items!: LenderOpenLoan[] | BorrowerOpenLoan[];

  private async execute(): Promise<{ failedIds?: string[] }> {
    const side = this.items[0].side;
    const ids = this.items.map((i: BorrowerOpenLoan | LenderOpenLoan) => i.id);

    const result = await this.$api.secLending.batchCancelRenegotiateLoans(side, ids);
    const failedIds = result.failedItems.map((i) => i.requestId);

    // failing ids only, we are losing the error messages here
    return { failedIds };
  }
}
</script>
<style lang="scss" scoped></style>
